import React from 'react';

/* This needs reimplemented when we have a proper way to handle images in the new setup (dependent on FHS)
    const imgUrl = new URL('../../images/gavekort.png', import.meta.url).href;
*/

const imgUrl = '/filer/static/gavekort.png';


interface PermissionBannerProps {
    onClick: () => void;
}

const PermissionBanner: React.FC<PermissionBannerProps> = ({ onClick }) => {
   return (
        <div className={'selfcare-page-content permission-banner'} onClick={onClick}>

            <img className='banner-image' src={imgUrl} alt="vind et gavekort med internet fra Hiper" />

            <p>
                <strong>Vind et gavekort til GoGift til en værdi af 1.000 kr.</strong><br/>
                <span className='button button--montserrat red rounded'>Læs mere</span>
            </p>
        </div>
    );
};

export default PermissionBanner;
